import { useEventTypeContext } from 'features/event_type_provider'
import {
  isSurfaceEtPaymentsUpfrontEligible,
  SurfaceEtPaymentsUpfrontExperiment
} from 'features/growth_experiments'

import { EditForm } from './sections/edit_form'
import { NewForm } from './sections/new_form'
import { SectionDetail } from './sections/section_detail'

const SectionPaneContent = ({ sectionKey, paymentsUpfrontVariant }) => {
  const { eventType, isCreation } = useEventTypeContext()
  const showPaymentsUpfront = Boolean(paymentsUpfrontVariant)

  if (sectionKey) {
    return (
      <SectionDetail
        sectionKey={sectionKey}
        eventType={eventType}
        showPaymentsUpfront={showPaymentsUpfront}
      />
    )
  }

  if (isCreation) {
    return (
      <NewForm
        showPaymentsUpfront={showPaymentsUpfront}
        paymentsUpfrontVariant={paymentsUpfrontVariant}
      />
    )
  }

  return (
    <EditForm
      showPaymentsUpfront={showPaymentsUpfront}
      paymentsUpfrontVariant={paymentsUpfrontVariant}
    />
  )
}

export const SectionPane = ({ sectionKey }) => {
  if (!isSurfaceEtPaymentsUpfrontEligible()) {
    return <SectionPaneContent sectionKey={sectionKey} paymentsUpfrontVariant={null} />
  }

  return (
    <SurfaceEtPaymentsUpfrontExperiment>
      {(paymentsUpfrontVariant) => (
        <SectionPaneContent
          sectionKey={sectionKey}
          paymentsUpfrontVariant={paymentsUpfrontVariant}
        />
      )}
    </SurfaceEtPaymentsUpfrontExperiment>
  )
}
